"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var CopyableLink = __importStar(require("./M_CopyableLink"));
var CtaButtonCombo = __importStar(require("./M_CtaButtonCombo"));
/** Represents header, sharing link and exit/cancel CTAs, for when the user wishes to exit the app
 */
var Component = function (p) {
    var _a;
    return (Preact.h(Preact.Fragment, null,
        Preact.h(Box_1.default, { paddingBottom: "36px" },
            Preact.h(Typography_1.default, { variant: "h4", textAlign: "center" }, p.titleText)),
        Preact.h(Box_1.default, { paddingBottom: "16px" },
            Preact.h(CopyableLink.Component, { linkToCopy: p.sharingUrlError ? p.linkError : (_a = p.sharingUrlResult) !== null && _a !== void 0 ? _a : p.linkLoading, copyToClipboard: p.copyToClipboard, helperText: p.linkHelperText, ctaText: p.linkCtaText })),
        Preact.h(CtaButtonCombo.Component, { primaryOnClick: p.onExit, primaryCopy: p.primaryCtaText, secondaryOnClick: p.onCancel, secondaryCopy: p.secondaryCtaText, secondaryVariant: "text", size: p.size, disabled: false, orientation: "vertical" })));
};
exports.Component = Component;
